export const GlobalVisualSearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className="global-visual-search-icon"
  >
    <path
      d="M1.5 17C1.5 17.8284 2.17157 18.5 3 18.5H8V19.5H3C1.61929 19.5 0.5 18.3807 0.5 17V12H1.5V17Z"
      fill="currentColor"
    />
    <path
      d="M19.5 17C19.5 18.3807 18.3807 19.5 17 19.5H12V18.5H17C17.8284 18.5 18.5 17.8284 18.5 17V12H19.5V17Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5.5C12.4853 5.5 14.5 7.51472 14.5 10C14.5 12.4853 12.4853 14.5 10 14.5C7.51472 14.5 5.5 12.4853 5.5 10C5.5 7.51472 7.51472 5.5 10 5.5ZM10 6.5C8.067 6.5 6.5 8.067 6.5 10C6.5 11.933 8.067 13.5 10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 8.067 11.933 6.5 10 6.5Z"
      fill="currentColor"
    />
    <path
      d="M8 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V8H0.5V3C0.5 1.61929 1.61929 0.5 3 0.5H8V1.5Z"
      fill="currentColor"
    />
    <path
      d="M17 0.5C18.3807 0.5 19.5 1.61929 19.5 3V8H18.5V3C18.5 2.17157 17.8284 1.5 17 1.5H12V0.5H17Z"
      fill="currentColor"
    />
    <path
      d="M15.5 3.5C16.0523 3.5 16.5 3.94772 16.5 4.5C16.5 5.05228 16.0523 5.5 15.5 5.5C14.9477 5.5 14.5 5.05228 14.5 4.5C14.5 3.94772 14.9477 3.5 15.5 3.5Z"
      fill="currentColor"
    />
  </svg>
)
